import { TIMELINE } from "../../lib/data";
import { TimelineItem } from "./timeline/TimelineItem";

export const Timeline = () => {
  return (
    <section
      id="career"
      data-testid="career-section"
      className="hairline-b border-b"
    >
      <div className="max-w-[1480px] mx-auto px-5 md:px-10 py-16 md:py-28">
        <div className="grid grid-cols-12 gap-6 mb-12 md:mb-20">
          <div className="col-span-12 md:col-span-4">
            <div className="text-[10.5px] tracking-[0.22em] uppercase opacity-50 mb-2">
              03 — Career
            </div>
            <h2 className="text-3xl md:text-5xl font-bold tracking-tight leading-[0.95]">
              Eight years,<br />four promotions.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-6 md:col-start-7 self-end">
            <p className="text-base md:text-lg leading-relaxed text-[var(--muted)] max-w-prose">
              A career built inside one agency — climbing from individual
              contributor to leading the largest business portfolio.
            </p>
          </div>
        </div>

        <div className="relative pl-6 md:pl-10">
          <div className="absolute left-0 top-2 bottom-2 w-px bg-[var(--rule)]" />
          {TIMELINE.map((item, i) => (
            <TimelineItem
              key={`${item.company}-${item.title}-${item.period}`}
              item={item}
              index={i}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
